import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import './registerServiceWorker'
import VueRouter from 'vue-router'
import { routes } from './routes'
import VeeValidate from 'vee-validate'
import VueLodash from 'vue-lodash'
import storage from 'vue-localstorage'
import './db'
import './auth'
import Airbrake from 'airbrake-js'
import VueWebP from 'v-webp'
import GSignInButton from 'vue-google-signin-button'
import FBSignInButton from 'vue-facebook-signin-button'

var settings = require('./settings/' + process.env.NODE_ENV + '.json')

Vue.use(VueRouter);
Vue.use(VeeValidate, { inject: false });

Vue.config.productionTip = false

Vue.use(VueLodash)

Vue.use(VueWebP)

Vue.config.productionTip = false

Vue.use(storage)

Vue.use(storage, {
  name: 'ls',
  bind: true
})

Vue.use(FBSignInButton)
Vue.use(GSignInButton)

var errbit = new Airbrake({
  projectId: 1,
  projectKey: settings.tracking.key,
  host: settings.tracking.host,
  environment: process.env.NODE_ENV
})

Vue.prototype.$err = async function (error) {
  var pkg = require('../package.json')

  var params = {
    version: pkg.version
  }

  if (error !== null && typeof error === 'object') {
    if (error.response !== null &&
      typeof error.response !== 'undefined' &&
      error.response.data !== null &&
      typeof error.response.data !== 'undefined') {
      params.info = error.response.data
    }

    if (error.name !== null && typeof error.name !== 'undefined') {
      params.name = error.name
    }
  }

  await errbit.notify({
    error: error,
    params
  })
}

const router = new VueRouter({ routes: routes });

new Vue({
  el: '#app',
  mode: 'hostory',
  router: router,
  components: { App },
  template: '<App/>',
  data: {
    trySync: true
  },

  render: h => h(App),
})